export default "__VITE_ASSET__39eca82b__"